import RoutePaths from '@/common/enum/RoutePaths.ts';

/** The reception center user guide, served from `public/guides/`. */
export const USER_GUIDE_URL = '/guides/REPUserGuide.pdf';

/**
 * Paths of the side-menu rows that run an action instead of opening a station or page. The menu
 * hands the chosen row's `path` to `onMenuClick`, so these rows are told apart by theirs; the `#`
 * keeps them from ever matching a route or the active path.
 */
export const SECTION_PATHS = {
  userGuide: '#user-guide',
  contactSupport: '#contact-support',
} as const;

export type SideMenuAction = 'userGuide' | 'contactSupport' | 'logout' | 'none' | 'navigate';

/**
 * What choosing a side-menu row does. The user-name row (`RoutePaths.SETTINGS`) and the unused
 * `RoutePaths.CONTACT` do nothing; every other path is Admin or a station entry.
 */
export const sideMenuAction = (path: string): SideMenuAction => {
  switch (path) {
    case SECTION_PATHS.userGuide:
      return 'userGuide';
    case SECTION_PATHS.contactSupport:
      return 'contactSupport';
    case RoutePaths.LOGOUT:
      return 'logout';
    case RoutePaths.SETTINGS:
    case RoutePaths.CONTACT:
      return 'none';
    default:
      return 'navigate';
  }
};
